import { useState, useEffect } from 'react';
import { SSRGlobal } from './Context';
import Img from './Img';



export default (props: {
  id?: string,
  onmentionclose?: () => void,
  readOnly?: boolean,
  placeholder?: string,
  loginrequired?: () => void,
  isMobile?: boolean,
  on?: (v: { text: string }) => void,


}) => {
  var [txt, setTxt] = useState('');
  var shift = false;
  var alt = false
  var ctrl = false
  let z = SSRGlobal()
  useEffect(() => {
    var t = document.getElementById("txtbottom")
    var d = document.getElementById("div")
    t.scrollTop = t.scrollHeight;
    t.style.height = '1rem';
    t.style.height = (t.scrollHeight) + 'px';
    d.style.height = t.scrollHeight + "px";
  })



  return <div style={{
    position: "fixed", display: "flex", justifyContent: "center", marginTop: 5,
    bottom: 15, left: 0, width: "100%", zIndex: 99
  }}>

    <f-csb id={props.id + "_mention"} class={z.styles.mentionhide}>
      <f-c><sp-2 /><f-11 id={props.id + "_mention_name"}></f-11></f-c>

      <Img src={global.cdn("/files/close.svg")} style={{ height: 20, margin:"0 10px", cursor:"pointer" }} on={(e) => {
        (e.target as any).parentNode.className = z.styles.mentionhide;
        props.onmentionclose?.()
      }} />
    </f-csb>

    <div id="div" className={z.styles.divsend} style={{
      position: "relative",
      maxWidth: "49rem", maxHeight: "25rem"
    }}>
      <textarea
        style={{
          width: "calc(100% - 20px)",
          margin: z.lang.dir == "rtl" ? "2px 10px 0px 5px" : "5px 5px 0px 10px",
          // paddingLeft: z.lang.dir == "rtl" ? 48 : null,
          // paddingRight: z.lang.dir == "ltr" ? 48 : null,
          direction: z.lang.dir as any,
          fontFamily: "inherit",
          // textAlign: z.lang.dir == "rtl"?"right":"left",
        }}
        className={z.styles.txtsend+" "+ z.styles.textboxbg}
        readOnly={props.readOnly}
        disabled={props.readOnly}
        placeholder={props.placeholder as any}
        id="txtbottom" dir="auto" spellCheck={false} defaultValue={txt}
        onClick={(e) => {
          if (!z.user.loggedin) {
            props.loginrequired?.()
            e.preventDefault();
          }
        }}
        onKeyDown={(e) => {
          if (!z.user.loggedin) {
            props.loginrequired?.()
            return
          }
          if ((e.code == "Enter" || e.code == "NumpadEnter" || e.key == "Enter") && !e.altKey && !e.shiftKey && !e.ctrlKey && txt.trim().length > 0) {
            if (props.isMobile) {
              return
            }

            let txt_ = txt;
            setTimeout(() => {
              props.on?.({ text: txt_ });
            }, 100);

            txt = ""
            setTxt('')
            e.target.value = ""
            e.currentTarget.value = "";
            e.preventDefault();
            return;
          }
        }}
        onKeyUp={(e) => {
          if (!z.user.loggedin) {
            props.loginrequired?.()
            return
          }
          setTxt(e.target.value)
        }} />





      {/* <div style={{
        position: "absolute",
        right: z.lang.dir == "ltr" ? 10 : null,
        left: z.lang.dir == "rtl" ? 10 : null,
        bottom: 4,
      }}>
        {txt.length == 0 ? null :
          <div style={{ paddingLeft: 10, paddingTop: 10, paddingRight: 10, cursor: "pointer", }}
            onClick={(e) => {
              if (txt.trim().length > 0) {
                document.getElementById("txtbottom").value = "";
                e.preventDefault();
                setTxt('')
                props.on?.({ text: txt });
                return;
              }
            }}>
              <Img src={global.cdn("/files/send.svg")} style={{
              width: 28, height: 28,
              transform: z.lang.dir == "rtl" ? "rotate(180deg)" : null
            }} />
            
            </div>
        }
      </div> */}



    </div>
  </div>
}